import { useMemo } from 'react';
import { UserRole } from '@/@types/auth';

function useAuthority(
  userAuthority: UserRole | null,
  authority: UserRole[] = [],
  emptyCheck = false,
) {
  return useMemo(
    () => (!authority?.length || !userAuthority ? !emptyCheck : authority.includes(userAuthority)),
    [authority, emptyCheck, userAuthority],
  );
}

export default useAuthority;
